import { StatusTag } from "../../../../components/chips/status-tag";
import { CONST_MEETING_STATUS_LIST } from "../../../../constants/lists";
import { getMeetingStatus } from "../../../../services/utils";

function MeetingStatus({ data }) {
  const status = getMeetingStatus(data);
  const statusConfig = CONST_MEETING_STATUS_LIST[status];

  if (!statusConfig?.label) return null;

  const { fontColor, bgColor } = statusConfig;

  return (
    <StatusTag
      text={statusConfig.label}
      fontColor={fontColor}
      bgColor={bgColor}
    />
  );
}

export { MeetingStatus };
